import React from "react";
import MetaComp from "../../components/meta-comp/MetaComp.component";
import LockScreenForm from "../../components/auth/LockScreenForm.component";
import LegalLinks from "../../components/auth/LegalLinks.component";
import ChatHelp from "../../components/chat-help/ChatHelp.component";
import "./Auth.styles.css";
import authBg from "../../assets/images/auth/BG.jpg";

const AccountLock = ({ t, refId }) => {
  return (
    <main className="cm-page-container cm-auth-page-container d-flex row mx-0">
      <MetaComp title={t("account_lock_page_title")} />
      <div className="col-sm-12 col-md-6 cm-auth-content-wrap d-flex flex-column">
        <div className="cm-auth-content-inner col-12 flex-grow-1 d-flex flex-column justify-content-center">
          <div>
            <LockScreenForm t={t} refId={refId} />
          </div>
        </div>
        <LegalLinks />
      </div>
      <div
        className="col-sm-6 py-8 cm-auth-bg-container position-relative d-none d-lg-block d-md-block w-md-50"
        style={{ backgroundImage: `url('${authBg}')` }}
      >
        <ChatHelp />
      </div>
    </main>
  );
};

export default AccountLock;
